import PassInformation from "./PassInformation";
import './passInformation.scss';

export default PassInformation;